//@flow
import AbstractAuthType from './AuthType';
import type { AuthResultEvent } from './AuthResultEvent';
import { AuthRealm } from './AuthMechanism';
const debug = require('../debug/debug')('wc:auth:BasicAuthType');

export default class BasicAuthType extends AbstractAuthType {

  constructor(authRealm: AuthRealm) {
    super(authRealm);
  }

  async login(): Promise<AuthResultEvent> {
    debug('[login()] in BasicAuthType');
    return {
      running: false,
      success: false
    };
  }

  abort(): void {
    if (debug.enabled) {
      debug('[abort()] Nothing to be done for Basic auth request');
    }
  }
}
